import React, { useCallback, useEffect, useState } from "react";
import { Modal, TimePicker, Input, Button, Form } from "antd";
import axios, { AxiosError, AxiosResponse } from "axios";

import { useTranslation } from "react-i18next";
import { useToast } from "../../../../hooks/toast";
import { IRequirement } from "../../../Project";
import FormItem from "../../../../components/FormItem";
import api from "../../../../services/api";

const { RangePicker } = TimePicker;

interface IScheduledDay {
  id: string;
  date: string;
  task_description: string | undefined | null;
  morning_start_time: string | undefined | null;
  morning_end_time: string | undefined | null;
  afternoon_start_time: string | undefined | null;
  afternoon_end_time: string | undefined | null;
  evening_start_time: string | undefined | null;
  evening_end_time: string | undefined | null;
}

interface IAssignActivityModalProps {
  activity?: IRequirement;
  visible: boolean;
  handleClose: () => void;
  type: "number_nf" | "number_fiche_service";
}

const TimeSheetAllocationModal: React.FC<IAssignActivityModalProps> = ({
  activity,
  visible,
  handleClose,
  type,
}) => {
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);
  const [sheetHours, setSheetHours] = useState<number | undefined>(undefined);

  const [form] = Form.useForm();

  const { t } = useTranslation(["activities"]);

  const generateErrorToast = useCallback(
    (response: AxiosResponse | undefined) => {
      let description;

      switch (response?.status) {
        case 404:
          description = "A atividade não foi encontrada";
          break;
        case 403:
          description =
            "As horas só podem ser apontadas pleo usuário atribuído";
          break;
        default:
          description =
            "Um erro occoreu ao atribuir a atividade, tente novamente";
      }

      addToast({
        type: "error",
        title: "Erro ao apontar horas",
        description,
      });
    },
    [addToast]
  );

  useEffect(() => {
    if (type === "number_fiche_service") {
      form.setFieldsValue({
        number_nf: "",
        number_fiche_service: activity?.number_fiche_service,
      });
    } else {
      form.setFieldsValue({
        number_fiche_service: "",
        number_nf: activity?.number_nf,
      });
    }
  }, [type, visible]);

  const handleSubmit = async (data: {
    number_fiche_service: string;
    number_nf: string;
  }) => {
    setLoading((old) => !old);
    let payload;
    if (type === "number_fiche_service") {
      payload = { number_fiche_service: data?.number_fiche_service };
    } else {
      payload = { number_nf: data.number_nf };
    }
    try {
      await api.patch(
        `activities/${activity?.id}/report_fiche_service`,
        payload
      );
      handleClose();
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const serverError = err as AxiosError;
        generateErrorToast(serverError.response);
      } else {
        console.log(err);
      }
    }
    setLoading((old) => !old);
  };

  const handleClearAndClose = () => {
    handleClose();
  };

  return (
    <Modal
      title={t(`modal_service.title.${type}`)}
      visible={visible}
      onOk={() => form.submit()}
      width={740}
      onCancel={() => handleClearAndClose()}
      okButtonProps={{
        loading,
      }}
      getContainer={false}
      destroyOnClose
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Form name="control-hooks" onFinish={handleSubmit} form={form}>
        <FormItem
          name={type}
          required
          label={t(`modal_service.${type}`)}
          initialValue={activity?.[type]}
          /* errors={validationErrors} */
        >
          <Input />
        </FormItem>
      </Form>
    </Modal>
  );
};

export default TimeSheetAllocationModal;
